const IBAN_PATTERN = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/;

export const normalizeIban = (value: string): string =>
  (value || '').replace(/\s+/g, '').toUpperCase();

export const isValidIban = (value: string): boolean => {
  const iban = normalizeIban(value);
  if (!IBAN_PATTERN.test(iban) || iban.length < 15 || iban.length > 34) {
    return false;
  }
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  const expanded = rearranged.replace(/[A-Z]/g, char => String(char.charCodeAt(0) - 55));
  let remainder = 0;
  for (const digit of expanded) {
    remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};
